var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "picture_as_pdf"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.667 1.66699H6.66699C5.75033 1.66699 5.00033 2.41699 5.00033 3.33366V13.3337C5.00033 14.2503 5.75033 15.0003 6.66699 15.0003H16.667C17.5837 15.0003 18.3337 14.2503 18.3337 13.3337V3.33366C18.3337 2.41699 17.5837 1.66699 16.667 1.66699ZM16.667 13.3337H6.66699V3.33366H16.667V13.3337ZM3.33366 5.00033H1.66699V16.667C1.66699 17.5837 2.41699 18.3337 3.33366 18.3337H15.0003V16.667H3.33366V5.00033ZM13.3337 10.0003V7.50033C13.3337 7.04199 12.9587 6.66699 12.5003 6.66699H10.8337V10.8337H12.5003C12.9587 10.8337 13.3337 10.4587 13.3337 10.0003ZM11.667 7.50033H12.5003V10.0003H11.667V7.50033ZM15.0003 9.16699H15.8337V8.33366H15.0003V7.50033H15.8337V6.66699H14.167V10.8337H15.0003V9.16699ZM8.33366 9.16699H9.16699C9.62533 9.16699 10.0003 8.79199 10.0003 8.33366V7.50033C10.0003 7.04199 9.62533 6.66699 9.16699 6.66699H7.50033V10.8337H8.33366V9.16699ZM8.33366 7.50033H9.16699V8.33366H8.33366V7.50033Z",
    fill: "#42526E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfReport);
export default __webpack_public_path__ + "static/media/pdf_report.189004e2f0e1ef2abb014c9961a4fb20.svg";
export { ForwardRef as ReactComponent };